import { render, staticRenderFns } from "./Engineering.vue?vue&type=template&id=647069e3"
import script from "./Engineering.vue?vue&type=script&lang=js"
export * from "./Engineering.vue?vue&type=script&lang=js"
import style0 from "./Engineering.vue?vue&type=style&index=0&id=647069e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports